import { Router } from '@angular/router';
import {
  Component,
  ComponentFactoryResolver,
  OnInit,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import { AuthenticationService } from '../../../auth/services/authentication.service';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UiStateStore } from 'src/app/shared/store/ui-state-store.service';
import { AuthenticationResult } from '../../../shared/models/authentication-result';
import { NewCredentials } from 'src/app/auth/models/credentials';
import { CustomeValidation } from '../../../shared/helpers/custome-validation';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from '../../../shared/components/modal/modal.component';
import { ChangePasswordAlertComponent } from './change-password-alert/change-password-alert.component';
import { AuthErrorCodes } from 'firebase/auth';
import { AUthErrorMessages } from '../../../shared/constants/auth-constants';

@Component({
  selector: 'app-dashboard-change-password',
  templateUrl: './dashboard-change-password.component.html',
  styleUrls: ['./dashboard-change-password.component.scss'],
})
export class DashboardChangePasswordComponent implements OnInit {
  form: FormGroup;
  accountId: string;
  failedAuthentication: boolean;
  failedAuthenticationReason: string;
  @ViewChild(TemplateRef) passwordChangeTemplate: TemplateRef<any>;
  constructor(
    private authenticationService: AuthenticationService,
    private formBuilder: FormBuilder,
    private uiState: UiStateStore,
    private router: Router,
    public resolver: ComponentFactoryResolver,
    public modalService: NgbModal
  ) {
    this.uiState.authenticatedUser.subscribe((user) => {
      if (!user) {
        return;
      }

      this.accountId = user.accountId;
    });
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      accountId: [this.accountId],
      currentPassword: ['', Validators.required],
      passwordGroup: this.formBuilder.group(
        {
          newPassword: ['', [Validators.required, Validators.minLength(8)]],
          confirmPassword: ['', [Validators.required, Validators.minLength(8)]],
        },
        { validator: this.checkPasswords }
      ),
    });
  }

  public save(): void {
    if (!this.form.valid) {
      return;
    }

    const newCredentials = new NewCredentials();
    newCredentials.accountId = this.form.value.accountId;
    newCredentials.currentPassword = this.form.value.currentPassword;
    newCredentials.newPassword = this.form.value.passwordGroup.newPassword;
    this.authenticationService
      .updatePassword(
        newCredentials.currentPassword,
        newCredentials.newPassword
      )
      .then((response) => {
        this.failedAuthentication = false;
        this.uiState.setSuccess('Your password has been successfully updated.');
        this.authenticationService.fireSignOut().then(() => {});
        this.onPasswordChangeModal();
      })
      .catch((error) => {
        this.failedAuthentication = true;
        if (error.code == AuthErrorCodes.INVALID_PASSWORD)
          this.failedAuthenticationReason = AUthErrorMessages.wrongPassword;
        else
          this.failedAuthenticationReason =
            CustomeValidation.validateServerErrorMessage(error);
        this.uiState.setError(
          `Error occured while changing updating the password.`
        );
      });
  }

  onDismissError = () => !this.failedAuthentication;

  onPasswordChangeModal = () => {
    const ComponentFactory = this.resolver.resolveComponentFactory(
      ChangePasswordAlertComponent
    );
    const modalRef = this.modalService.open(ModalComponent, {
      size: 'lg',
      backdrop: 'static',
    });
    modalRef.componentInstance.setContent(ComponentFactory);
  };

  checkPasswords(group: FormGroup) {
    // here we have the 'passwords' group
    let pass = group.get('newPassword').value;
    let confirmPass = group.get('confirmPassword').value;

    return pass === confirmPass ? null : { notSame: true };
  }
}
